// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Link } from 'react-router-dom';
import { PACKAGE_VERSION } from '~components/internal/environment';
import AwsUiLink from '~components/link';
import pagesContext from '../pages-context';
function createPagesTree(pages) {
    const tree = { name: '.', items: [] };
    function putInTree(segments, node, item) {
        if (segments.length === 0) {
            node.href = item;
        }
        else {
            let match = node.items.filter(item => item.name === segments[0])[0];
            if (!match) {
                match = { name: segments[0], items: [] };
                node.items.push(match);
            }
            putInTree(segments.slice(1), match, item);
            // make directories to be displayed above files
            node.items.sort((a, b) => Math.min(b.items.length, 1) - Math.min(a.items.length, 1));
        }
    }
    for (const page of pages) {
        const segments = page.split('/');
        putInTree(segments, tree, page);
    }
    return tree;
}
function TreeItemView({ item }) {
    return (React.createElement("li", null,
        item.href ? (React.createElement(Link, { to: item.href, component: AwsUiLink }, item.name)) : (React.createElement("b", { style: { fontSize: '1.6rem' } }, item.name)),
        React.createElement("ul", { style: { marginBlock: 0, marginInline: 0 } }, item.items.map(item => (React.createElement(TreeItemView, { key: item.name, item: item }))))));
}
export default function IndexPage() {
    const pages = pagesContext.keys().map(pagePath => pagePath.replace(/^\.\//, '').replace(/\.page\.tsx$/, ''));
    const tree = createPagesTree(pages);
    return (React.createElement("div", { style: { maxWidth: 800, margin: '0 auto' } },
        React.createElement("h1", null, "Welcome!"),
        React.createElement("p", null,
            "Build info: ",
            PACKAGE_VERSION),
        React.createElement("p", null, "Select a page:"),
        React.createElement("ul", null, tree.items.map(item => (React.createElement(TreeItemView, { key: item.name, item: item }))))));
}
